export default "__VITE_ASSET__RIV0iJTL__"